import assetService from "../../../../services/assetService/assetService";
import { CACHE_KEY_ASSETS } from "../../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AssetInterface } from "../../../../models/AssetModel/Asset";

interface AddAssetContext {
  previousAsset: AssetInterface[];
}

const useAddAsset = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<AssetInterface, Error, AssetInterface, AddAssetContext>({
    mutationFn: assetService.Save,

    onMutate: () => {
      const previousAsset =
        queryClient.getQueryData<AssetInterface[]>([
          CACHE_KEY_ASSETS,
          page,
          pageSize,
        ]) || [];

      return { previousAsset };
    },

    onSuccess: (savedAsset) => {
      queryClient.setQueryData<AssetInterface[]>(
        [CACHE_KEY_ASSETS, page, pageSize],
        (asset) => (asset ? [savedAsset, ...asset] : [savedAsset])
      );
    },

    onError: (error, newAsset, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetInterface[]>(
        [CACHE_KEY_ASSETS, page, pageSize],
        context.previousAsset
      );
    },
  });
};

export default useAddAsset;
